export const setValueAs = value => value || '';

export const getDirtyFields = (
    data: Record<string, any>,
    dirtyFields: Record<string, any>,
) => {
    const dirtyFieldsArray = Object.keys(dirtyFields);
    return dirtyFieldsArray.reduce((acc, key) => {
        if (data[key] !== dirtyFields[key]) acc[key] = data[key];
        return acc;
    }, {});
};

export const closeOptions = (all?: boolean) => {
    const selector =
        'div.MuiBackdrop-root.MuiBackdrop-invisible.MuiModal-backdrop';
    if (all) {
        Array.from(document.querySelectorAll(selector))
            .reverse()
            .forEach(el => el.click());
        return;
    }
    document.querySelector(selector)?.click();
};
